import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { getAxiosInstance } from '../../../../../../../../helpers/get_axios_instance'
import { lrsAdapter } from '../../../../../../../../helpers/lrs_adapter'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarTransileView } from '../components/OperacionEliminarTransileView'

const anularTransile = async (siloOrigen, siloDestino) =>
  lrsAdapter(
    await getAxiosInstance().delete('/operacion_transile_silos', {
      params: {
        r: {
          clave: {
            silo_origen: siloOrigen,
            silo_destino: siloDestino
          }
        }
      }
    })
  )

export const OperacionEliminarTransile = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo: { nombreCorto: siloOrigen }, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarTransileView
        siloOrigen={siloOrigen}
        aceptar={async ({ siloDestino }) => {
          try {
            await anularTransile(siloOrigen, siloDestino)
            closeDialog()
            enqueueSnackbar('Anulado de transile correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de transile incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ELIMINAR_TRANSILE_SILO')
        }, [closeDialog])}
      />
    )
  })
)
